<template>
    <a class="main-form__login-email-a mb-0"
       style=""
       :href="url+'?email='+email.replace('+', '%2b')"
    >
        CONTINUE
    </a>
</template>
<script>
    export default {
        props: ['url'],
        data: function () {
            return {
                email: '',
            }
        },
        mounted() {
            const _this = this;
            $( "#email" ).on('keyup', function() {
                _this.email = $(this).val();
            });
        }
    }
</script>
